import api from "@/services/axiosInstance";

const API_BASE_URL = process.env.VUE_APP_BACKEND_URL;
const content = "user";
const version = "v1";

export const fetchV1Roles = async (page = 1, pageSize = 5) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  let URL = `${API_BASE_URL}/${content}/${version}/roles/?page_size=${pageSize}&page=${page}`;

  console.log("Roles API:", URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching roles:", error);
    throw error;
  }
};

export const searchV1Roles = async (query = "", page = 1, pageSize = 8) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  const URL = `${API_BASE_URL}/${content}/${version}/roles?page_size=${pageSize}&page=${page}&search=${encodeURIComponent(
    query
  )}`;

  console.log("Search Roles API:", URL);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error searching roles:", error);
    throw error;
  }
};

export const createV1Role = async (data) => {
  const URL = `${API_BASE_URL}/${content}/${version}/roles/`;
  try {
    const response = await api.post(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating role at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied to create an author" };
    }

    throw error;
  }
};

export const deleteV1Role = async (id) => {
  const URL = `${API_BASE_URL}/${content}/${version}/roles/${id}/`;

  try {
    const response = await api.delete(URL);
    return response.data;
  } catch (error) {
    console.error("Error deleting role at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied to delete the role" };
    }

    throw error;
  }
};

export const fetchV1Permissions = async (page = 1, pageSize = 5) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  let URL = `${API_BASE_URL}/${content}/${version}/permissions?page_size=${pageSize}&page=${page}`;

  console.log("Permissions API:", URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching permission:", error);
    throw error;
  }
};

export const searchV1Permissions = async (
  query = "",
  page = 1,
  pageSize = 8
) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  const URL = `${API_BASE_URL}/${content}/${version}/permissions?page_size=${pageSize}&page=${page}&search=${encodeURIComponent(
    query
  )}`;

  console.log("Search Permissions API:", URL);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error searching permissions:", error);
    throw error;
  }
};

export const fetchV1Users = async (page = 1, pageSize = 5) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  let URL = `${API_BASE_URL}/${content}/${version}/list?page_size=${pageSize}&page=${page}`;

  console.log("Users API:", URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching user:", error);
    throw error;
  }
};

export const createV1User = async (data) => {
  const URL = `${API_BASE_URL}/${content}/${version}/create`;
  try {
    const response = await api.post(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating user at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied to create an user" };
    }

    throw error;
  }
};
